// 完整的API服务（使用request工具）
import { httpGet, httpPost } from './request'
import axios from 'axios'

// 模拟数据（用于开发环境）
const now = new Date();
const mockChatlist = [
  {
    id: 1,
    user: {
      name: '妈咪',
      img: 'static/images/mother.jpg'
    },
    messages: [
      {
        content: '么么哒，妈咪爱你',
        date: now,
        self: false
      },
      {
        content: '按回车可以发送信息，还可以给我发送表情哟',
        date: now,
        self: false
      }
    ],
    index: 1,
    unreadCount: 2
  },

  {
    id: 3,
    user: {
      name: '机器人',
      img: 'static/images/vue.jpg'
    },
    messages: [
      {
        content: '我会跟你聊聊天的哟',
        date: now,
        self: false
      }
    ],
    index: 3,
    unreadCount: 0
  }
]

// 当前登录用户
const currentUser = {
  name: 'ratel',
  img: 'static/images/UserAvatar.jpg'
}




// API服务（使用request工具，同时保留模拟数据功能）
const api = {
  // 查询IP信息
  getIPInfo(ip) {
    // 由于是第三方API，不使用项目默认的axios实例（避免添加不必要的认证头）
    https://ip-api.io/json?ip=101.44.82.153
    return axios.get(` https://api.ip.sb/geoip/${ip}`)
      .then(response => response.data)
      .catch(error => {
        console.error('IP查询失败:', error);
        return Promise.reject(error);
      });
  },
  // 发送认证信息
  sendAuth(params) {
    return httpPost('/game/api/sendAuth',params)
  },

  // 获取认证状态
  getAuthStatus(params) {
    console.log(params);

    return httpPost('/game/api/getAuthStatus', params)
  },
  getChatlist(params) {
    return httpGet('/game/api/getContactList', params)
  },
  // 获取特定好友的聊天记录
  getChatMessages(userId, params = {}) {

    params = { ...params, userId}
    return httpGet('/game/api/getcontactMessageList', params)
  },

  // 发送消息
  sendMessage(userId, content, self = true) {


    return httpPost('game/api/sendMessage', { userId: userId, content:content })
  },

  // 标记消息为已读
  markAsRead(friendId) {
    const useMock = process.env.NODE_ENV === 'development'

    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const chat = mockChatlist.find(item => item.id === parseInt(friendId))
          if (chat) {
            chat.unreadCount = 0
            resolve(true)
          } else {
            resolve(false)
          }
        }, 200)
      })
    }

    return httpPost(`/api/chat/mark-as-read/${friendId}`)
  },

  // 轮询获取新消息
  pollNewMessages() {
    const useMock = process.env.NODE_ENV === 'development'

    if (useMock) {
      return new Promise((resolve) => {
        setTimeout(() => {
          // 随机模拟有新消息的情况
          const hasNewMessage = Math.random() > 0.7
          if (hasNewMessage) {
            // 随机选择一个好友
            const randomFriendIndex = Math.floor(Math.random() * mockChatlist.length)
            const friendId = mockChatlist[randomFriendIndex].id

            // 随机生成一条新消息
            const newMessageContent = `这是一条新消息 ${Math.random().toString(36).substr(2, 5)}`

            // 添加到聊天记录并增加未读消息数
            return this.sendMessage(friendId, newMessageContent, false)
              .then(newMessage => {
                resolve({
                  friendId,
                  newMessage,
                  unreadCount: mockChatlist[randomFriendIndex].unreadCount
                })
              })
          } else {
            resolve(null)
          }
        }, 5000) // 5秒轮询一次
      })
    }

    return httpGet('/api/chat/poll-new-messages')
  },



}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js